//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('counters', {
//        templateUrl: 'views/components/views/counters/counters.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'countersService', 'rememberService', 'ttGridFactory', function (stateService, utilityService, countersService, rememberService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                searchtext: ''
//            };

//            let timer = {
//                searchtext: null
//            };

//            vm.model = {
//                gridReady: false,
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onSearchTextChanged('') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => vm.onSearchTextChanged(vm.model.setting.searchtext) }
//                ],
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_counters_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadSetting() {
//                vm.model.setting = (await countersService.getCounters())[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2553,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                if (timer[id]) clearTimeout(timer[id]);

//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                if (vm.model.setting.searchtext > '') {
//                    timer[id] = setTimeout(() => {
//                        return rememberService.remember(variableNames[id], variableValue);
//                    }, 1000);
//                } else {
//                    return rememberService.remember(variableNames[id], variableValue);
//                }
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region SEARCH TEXT FUNCTION

//            vm.onSearchTextChanged = function (value) {
//                vm.model.setting.searchtext = value;
//                vm.model.searchTextButtons[1].icon = 'fas fa-spinner fa-spin';

//                rememberFunc('searchtext');

//                vm.grid.gridfunc.read().then(() => vm.model.searchTextButtons[1].icon = 'fas fa-search');
//            }

//            // #endregion SEARCH TEXT FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
